import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import {
  LayoutModule,
  TileLayoutComponent as KendoTileLayoutComponent,
  TileLayoutItemComponent,
} from "@progress/kendo-angular-layout";

@Component({
  selector: "app-tile-layout",
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    TileLayoutItemComponent,
    KendoTileLayoutComponent,
  ],
  templateUrl: "./tile-layout.component.html",
  styleUrls: ["./tile-layout.component.scss"],
})
export class TileLayoutComponent implements OnChanges {
  @Input() firstLayoutItems: any[] = [];
  @Input() secondLayoutItems: any[] = [];

  refreshing: { [index: number]: { [group: string]: boolean } } = {};
  lastRefreshed: { [key: string]: string } = {};

  constructor() {}

  ngOnInit(): void {
    this.initializeRefreshing();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['firstLayoutItems'] || changes['secondLayoutItems']) {
      this.initializeRefreshing();
    }
  }

  private initializeRefreshing(): void {
    this.refreshing = {};
    this.lastRefreshed = {};

    this.firstLayoutItems.forEach((_, i) => {
      this.refreshing[i] = { first: false };
      this.lastRefreshed[`first-${i}`] = new Date().toLocaleTimeString();
    });

    this.secondLayoutItems.forEach((_, i) => {
      this.refreshing[i] = { second: false };
      this.lastRefreshed[`second-${i}`] = new Date().toLocaleTimeString();
    });
  }

  refreshComponent(index: number, group: "first" | "second"): void {
    const key = `${group}-${index}`;
    this.refreshing[index][group] = true;
    setTimeout(() => {
      this.refreshing[index][group] = false;
      this.lastRefreshed[key] = new Date().toLocaleTimeString();
    });
  }

  public onReorder(event: any): void {
    console.log(event.items.map((item: any) => item.order));
  }
}
